export const campaignDateRange = (campaign, now = new Date()) => {
  const startDate = new Date(campaign?.startTime);
  const campaignEnd = new Date(campaign?.endTime);
  if (Number.isNaN(startDate.getTime())) return null;
  const endDate = Number.isNaN(campaignEnd.getTime()) || campaignEnd > now ? now : campaignEnd;
  return { startDate, endDate: endDate < startDate ? startDate : endDate };
};

export const storeViewRequest = ({ portalId, startDate, endDate, timeZone, campaignId, targetSiteId }) => {
  const exclusiveEnd = new Date(endDate);
  exclusiveEnd.setSeconds(exclusiveEnd.getSeconds() + 1, 0);
  const selection = {
    ...(campaignId ? { campaignIds: [campaignId] } : {}),
    ...(targetSiteId ? { targetSiteIds: [targetSiteId] } : {})
  };
  return {
    scope: { brandPortalId: portalId },
    period: { startTime: new Date(startDate).toISOString(), endTime: exclusiveEnd.toISOString(), timeZone },
    ...(Object.keys(selection).length ? { selection } : {})
  };
};

export const categoryPoints = response =>
  (response?.categorySeries?.points || [])
    .map(point => ({
      id: point.key,
      label: point.label || point.key,
      value: Number(point.value || 0),
      latitude: point.latitude == null ? NaN : Number(point.latitude),
      longitude: point.longitude == null ? NaN : Number(point.longitude)
    }))
    .sort((a, b) => b.value - a.value);

export const attributionMapPoints = response =>
  (response?.categorySeries?.points || []).map(point => ({
    id: point.key,
    siteId: point.values?.site_id || point.key?.slice(point.key.indexOf(':') + 1),
    label: point.label || point.key,
    value: Number(point.value || 0),
    markerValue: Number(point.values?.marker_value || 1),
    latitude: point.latitude == null ? NaN : Number(point.latitude),
    longitude: point.longitude == null ? NaN : Number(point.longitude),
    kind: point.values?.kind === 'store' ? 'target' : 'media'
  }));

export const timeSeries = (response, timeZone) => {
  const format = new Intl.DateTimeFormat('en-US', { month: '2-digit', day: '2-digit', timeZone });
  const series = response?.timeSeries?.series || [];
  return {
    categories: (series[0]?.points || []).map(point => format.format(new Date(point.timestamp))),
    data: series.map(item => ({
      label: item.label || item.key,
      value: (item.points || []).map(point => ({
        label: format.format(new Date(point.timestamp)),
        value: Number(point.value || 0)
      }))
    }))
  };
};
